import { useEffect } from 'react';
import { on } from '@atlassian/forge-ui/events';

export const useReemitReadyEvent = (enabled: boolean): void => {
	useEffect(() => {
		if (!enabled) {
			return;
		}
		const origin = window.location.origin;
		const readyEventSub = on('EXTENSION_READY', async ({ localId }) => {
			window.postMessage(
				{
					source: 'forge-extension',
					type: 'EXTENSION_READY',
					localId,
				},
				origin,
			);
		});

		return () => {
			readyEventSub.unsubscribe();
		};
	}, [enabled]);
};
